import ButtonBase from '@material-ui/core/ButtonBase';
import { useTheme } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { forwardRef } from 'react';
import * as React from 'react';
import cn from 'classnames';
import CircularProgress from 'raydiant-elements/core/CircularProgress';
import { Theme } from 'raydiant-elements/theme';
import useStyles from './TreeViewItemLabel.styles';

export interface TreeViewItemLabelProps {
  icon: React.ReactNode;
  label: React.ReactNode;
  indent?: number;
  isExpandable?: boolean;
  isExpanded?: boolean;
  isLoading?: boolean;
  isDragging?: boolean;
  onClick?: React.MouseEventHandler<any>;
  onExpansion?: React.MouseEventHandler<any>;
}

export const TreeViewItemLabel: React.FunctionComponent<
  TreeViewItemLabelProps
> = (
  {
    icon,
    label,
    indent = 0,
    isExpanded = false,
    isExpandable = false,
    isLoading = false,
    isDragging = false,
    onExpansion,
    onClick,
  },
  ref,
) => {
  const classes = useStyles();
  const theme = useTheme<Theme>();
  return (
    <div
      ref={ref}
      className={cn(classes.root, isDragging && classes.dragging)}
      onClick={onClick}
    >
      <div
        className={classes.icon}
        style={{ paddingLeft: theme.spacing(indent) }}
      >
        {icon}
      </div>
      <div className={classes.labelText}>{label}</div>
      {isLoading && <CircularProgress size={12} />}
      {isExpandable && (
        <ButtonBase
          className={classes.toggleExpand}
          disableRipple
          onClick={onExpansion}
        >
          <div className={classes.toggleExpandHitArea} />
          {isExpanded ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
        </ButtonBase>
      )}
    </div>
  );
};

// @ts-ignore
export default forwardRef(TreeViewItemLabel);
